import React, {
  useEffect,
  useContext,
  useRef,
  Fragment,
  useState,
  use,
} from "react";
import { AppContext } from "../context";
import {
  addImageToList,
  setLog,
  userLogs,
  patLogs,
  translateText,
  setKotakRecapMenuSection,
  getConstraint,
  getAspectRatioClientList,
  setGlobalImageQueue,
  setCameraOpenFlag,
  getCameraOpenFlag,
  imageFeedbackLambda,
  getVinFeedback,
  getDocumentTagIndex,
  getWebpImageFormat,
  getImgQualityFactor
} from "../context/utils";
import cameraImg from "../img/camera.png";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Rotate from "./Rotate";
import VINImg from "../img/VINPopup.png";
import car_inspection from "../img/vin.png";
import { Check } from 'lucide-react';
import dashboard from "../img/dashboard.jpg";
// import image1 from "../img/odometer1.jpg";
// import ReactGA from "react-ga4";

const screenfull = require("screenfull");
let imageCaptured = false;
let image = {};
// let cameraStarted = false;
let track = null;
let imgUrl = null;
let logBugs = true;
let videoEl;
let vinCapturedCount = 0;
let checkVin = [];
let timeout = null;
let vinEditToastId = null;

const SingleImage = () => {
  const {
    inspectionId,
    clientId,
    stepCovered,
    setStepCovered,
    condition,
    config,
    currentBlock,
    setCurrentPage,
    setCondition,
    setScreen,
    mandatory,
    setMandatory,
    isLandscape,
    setLandscape,
    isIOS
  } = useContext(AppContext);
  let webCamPromise = null;

  //Reference vaiables
  const singleScreen = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const startBtn = useRef();
  const imgRef = useRef();
  const backRef = useRef();
  const divImgRef = useRef();
  const guidanceTextRef = useRef();
  const redLineVINcontainer = useRef();
  const cardRef = useRef();
  const cardDashboardRef = useRef();
  const cardDashboardRef1 = useRef();
  const feedBackPopUp = useRef();
  const crossTickBtn = useRef();
  const feedBackPopText = useRef();
  const carInspectionRef = useRef();
  const headerText1 = useRef();
  const feedbackBtnRef = useRef();
  const vinInputRef = useRef();
  // const headerText2 = useRef();
  const imageRef = useRef();
  const feedbackSuccessTopPopRef = useRef();
  const feedbackSuccessBottomPopRef = useRef();
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [feedbackBtnText, setFeedbackBtnText] = useState("");

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  if (logBugs) {
    patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
    userLogs({
      position: 8,
      last_page: `${currentBlock.tag} Module`,
      inspectionId,
    });
  }
  logBugs = false;

  const startCamera = () => {
    try {
      if (timeout) clearTimeout(timeout);
      webCamPromise = navigator.mediaDevices
        .getUserMedia(getConstraint(config, clientId))
        .then((stream) => {
          if (window.stream) {
            window.stream.getTracks().forEach(track => track.stop());
            window.stream = null;
          }
          window.stream = stream;
          track = stream.getTracks()[0]
          videoEl = videoRef.current;
          if (videoEl) {
            videoEl.srcObject = stream;
            videoEl.onloadedmetadata = () => {
              feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
              if (imgUrl) {
                divImgRef.current.src = imgUrl;
                imgRef.current.style.display = "block";
                if (getVinFeedback() && !["client_1511", "client_1298", "client_1298_prod", "client_1298_dev"].includes(clientId) && currentBlock["tag"] === "VIN" && vinCapturedCount === 1) {
                  if (checkVin.length === 0) {
                    feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
                  }
                  else if (!checkVin[1]) {
                    feedBackPopUp.current.style.display = "flex";
                    feedbackBtnRef.current.style.display = "flex";
                    carInspectionRef.current.style.width = "10dvw";
                    if (["image captured is not VIN"].includes(checkVin[0])) {
                      feedBackPopText.current.innerHTML = getTranslateText("It looks like the image doesn’t contain a #. Please try capturing it again.").replace("#", currentBlock["id"]);
                    }
                    else if (["The chassis no is not clearly visible"].includes(checkVin[0])) {
                      feedBackPopText.current.innerHTML = getTranslateText("The # isn’t clearly visible. Please try capturing the image again.").replace("#", currentBlock["id"]);
                    }
                  }
                  else if (checkVin[1]) {
                    if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                    if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "flex";
                    if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "flex";
                    setFeedbackBtnText(getTranslateText("Proceed"));
                    if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) {
                      timeout = setTimeout(() => {
                        feedbackSuccessTopPopRef.current.style.display = "none";
                        feedbackSuccessBottomPopRef.current.style.display = "none";
                        imageNext();
                      }, 4000);
                    }
                  }
                  crossTickBtn.current.style.display = "none";
                }
              }
              else setWhiteBlock();
              if (currentBlock["tag"] === "VIN") {
                if (
                  !Object.keys(config["single-image"]).includes("vin_popup") &&
                  !config["single-image"]["vin_popup"]
                ) {
                  setTimeout(() => {
                    if (startBtn.current) startBtn.current.style.display = "block";
                  }, 300);
                }
              } else {
                setTimeout(() => {
                  if (startBtn.current) startBtn.current.style.display = "block";
                }, 500);
              }
              // cameraStarted = true;
              setCameraOpenFlag(true);
            };
          }
          else {
            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.onloadedmetadata = () => {
                  feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
                  if (imgUrl) {
                    divImgRef.current.src = imgUrl;
                    imgRef.current.style.display = "block";
                    if (getVinFeedback() && !["client_1511", "client_1298", "client_1298_prod", "client_1298_dev"].includes(clientId) && currentBlock["tag"] === "VIN" && vinCapturedCount === 1) {
                      if (checkVin.length === 0) {
                        feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
                      }
                      else if (!checkVin[1]) {
                        feedBackPopUp.current.style.display = "flex";
                        feedbackBtnRef.current.style.display = "flex";
                        carInspectionRef.current.style.width = "10dvw";
                        if (["image captured is not VIN"].includes(checkVin[0])) {
                          feedBackPopText.current.innerHTML = getTranslateText("It looks like the image doesn’t contain a #. Please try capturing it again.").replace("#", currentBlock["id"]);
                        }
                        else if (["The chassis no is not clearly visible"].includes(checkVin[0])) {
                          feedBackPopText.current.innerHTML = getTranslateText("The # isn’t clearly visible. Please try capturing the image again.").replace("#", currentBlock["id"]);
                        }
                      }
                      else if (checkVin[1]) {
                        if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                        if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "flex";
                        if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "flex";
                        setFeedbackBtnText(getTranslateText("Proceed"));
                        if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) {
                          timeout = setTimeout(() => {
                            feedbackSuccessTopPopRef.current.style.display = "none";
                            feedbackSuccessBottomPopRef.current.style.display = "none";
                            imageNext();
                          }, 4000);
                        }
                      }
                      crossTickBtn.current.style.display = "none";
                    }
                  }
                  else setWhiteBlock();
                  setCameraOpenFlag(true);
                  if (currentBlock["tag"] === "VIN") {
                    if (
                      !Object.keys(config["single-image"]).includes("vin_popup") &&
                      !config["single-image"]["vin_popup"]
                    ) {
                      setTimeout(() => {
                        if (startBtn.current) startBtn.current.style.display = "block";
                      }, 500);
                    }
                  } else {
                    setTimeout(() => {
                      if (startBtn.current) startBtn.current.style.display = "block";
                    }, 500);
                  }
                };
              }
            }, 200);
          }
        });
    } catch (error) {
      console.log(err);
    }
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };


  const captureImg = () => {
    //patLogs("Image capture button clicked", inspectionId);
    const cnv = canvasRef.current;
    const vw = videoRef.current;
    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;
    cnv.getContext("2d").drawImage(vw, 0, 0);
    const imgData = getWebpImageFormat() && !isIOS
      ? cnv.toDataURL("image/webp", getImgQualityFactor())
      : cnv.toDataURL("image/jpeg");
    imgUrl = imgData;
    divImgRef.current.src = imgData;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    image = {
      name: Array.isArray(currentBlock["tag"]) ? `${getDocumentTagIndex()}.jpg` : `${currentBlock["tag"]}.jpg`,
      imgData: imgData,
      tag: Array.isArray(currentBlock["tag"]) ? getDocumentTagIndex() : currentBlock["tag"],
      web_region: null,
      angle: null,
      region: region,
      videoData: null,
      dialStatus: null,
      currentBlockName: currentBlock["id"]
    };
    if (["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(currentBlock["tag"])) redLineVINcontainer.current.style.display = "none";
    if (currentBlock["tag"] === "VIN") {
      image["vinFeedback"] = ["client_1511", "client_1298", "client_1298_prod", "client_1298_dev"].includes(clientId) ? false : getVinFeedback();
      if (vinCapturedCount !== 0) image["vinNumber"] = "";
    }
    imgRef.current.style.display = "block";
  };

  const imageRetake = () => {
    setStepCovered([...stepCovered]);
    setMessage("");
    // patLogs("retake button clicked for capture new image again", inspectionId);
    imgUrl = null;
    if (
      ["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(
        currentBlock["tag"]
      )
    )
      redLineVINcontainer.current.style.display = "flex";
    imgRef.current.style.display = "none";
  };

  const vinCheckingHanlder = async () => {
    vinCapturedCount++;
    crossTickBtn.current.style.display = "none";
    feedBackPopUp.current.style.display = "flex";
    checkVin = await imageFeedbackLambda({
      inspection_id: inspectionId,
      image: getWebpImageFormat() && !isIOS ? image["imgData"].replace(/^data:image\/webp;base64,/, "") : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
      tag: currentBlock["tag"],
      Vin_feedback: true,
      client_id: clientId,
      type: "vin",
      region: image["region"]
    });
    let feedbackRes = {
      result: checkVin,
      region: image["region"]
    }
    //console.log("vin feedback response :::: ", checkVin);
    if (checkVin && checkVin[0]) patLogs(`VIN Feedback: ${checkVin[0]}`, inspectionId);
    else patLogs(`VIN Feedback: ${JSON.stringify(feedbackRes)}`, inspectionId);
    setMessage(checkVin[0]);
    carInspectionRef.current.style.width = "10dvw";
    if (checkVin && checkVin[1]) {
      // Handle the case where VIN check success and allow the user to submit
      feedBackPopUp.current.style.display = "none";
      feedbackSuccessTopPopRef.current.style.display = "flex";
      if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) feedbackSuccessBottomPopRef.current.style.display = "none";
      else feedbackSuccessBottomPopRef.current.style.display = "flex";
      setFeedbackBtnText(getTranslateText("Proceed"));
      if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) {
        timeout = setTimeout(() => {
          feedbackSuccessTopPopRef.current.style.display = "none";
          // feedbackSuccessBottomPopRef.current.style.display = "none";
          imageNext();
        }, 4000);
      }
    }
    else {
      // Handle the case where VIN check fails and allow user to recapture
      feedbackBtnRef.current.style.display = "flex";
      setFeedbackBtnText(getTranslateText("Recapture image"));
      if (["image captured is not VIN"].includes(checkVin[0])) {
        feedBackPopText.current.innerHTML = getTranslateText("It looks like the image doesn’t contain a #. Please try capturing it again.").replace("#", currentBlock["id"]);
      }
      else if (["The chassis no is not clearly visible"].includes(checkVin[0])) {
        feedBackPopText.current.innerHTML = getTranslateText("The # isn’t clearly visible. Please try capturing the image again.").replace("#", currentBlock["id"]);
      }
      else feedBackPopText.current.innerHTML = getTranslateText("The # isn’t clearly visible. Please try capturing the image again.").replace("#", currentBlock["id"]);
    }
  }

  const imageNext = () => {
    setGlobalImageQueue(image)
    logBugs = true;
    if (imageCaptured) return;
    patLogs(
      `tick button clicked and image is sent for uploading , ${currentBlock["tag"]} module is completed`,
      inspectionId
    );
    // cameraStarted = false;
    setCameraOpenFlag(false);
    imageCaptured = true;
    if (currentBlock["mandatory"]) {
      let temp1 = mandatory;
      temp1[currentBlock["id"]] = "completed";
      setMandatory(temp1);
    }
    let temp = condition;
    temp[currentBlock["id"]] = "completed";
    setKotakRecapMenuSection(currentBlock["tag"]);
    setCondition(temp);
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
    setLog(`${currentBlock["tag"]} was captured`);
    // add image here for sending
    image["vinNumber"] = message;
    addImageToList(image);
    window.stream = null;
    track.stop();
    imgUrl = null;
  };

  const back = () => {
    logBugs = true;
    patLogs("back button clicked", inspectionId);
    window.stream = null;
    track.stop();
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
    // cameraStarted = false;
    setCameraOpenFlag(false);
  };

  const handleVinChange = (e) => {
    let value = e.target.value;

    // 1️⃣ Allow only alphabets and numbers (remove special characters)
    value = value.replace(/[^a-zA-Z0-9]/g, '');

    // 2️⃣ Check if length exceeds 17 characters
    if (value.length > 17) {
      // Only show toast if not already showing
      if (!vinEditToastId || !toast.isActive(vinEditToastId)) {
        vinEditToastId = toast.error(getTranslateText("You can enter up to 17 characters"), {
          position: "bottom-right",
          theme: "colored"
        });
      }
      return; // stop updating state
    }
    setMessage(value.toUpperCase());
  };
  const formatVinForDisplay = (rawVin) => {
    return rawVin.toUpperCase();
  };

  const setWhiteBlock = () => {
    setTimeout(() => {
      if (["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(currentBlock["tag"])) {
        if (
          currentBlock["tag"] === "VIN" &&
          Object.keys(config["single-image"]).includes("vin_popup") &&
          config["single-image"]["vin_popup"]
        )
          cardRef.current.style.display = "flex";
        else {
          if (!((Object.keys(config["single-image"]).includes("instruction1_tag") || Object.keys(config["single-image"]).includes("instruction2_tag")) && [config["single-image"]["instruction2_tag"] ? config["single-image"]["instruction2_tag"] : "", config["single-image"]["instruction1_tag"] ? config["single-image"]["instruction1_tag"] : ""].includes(currentBlock["tag"]))) redLineVINcontainer.current.style.display = "flex";
        }
        switch (currentBlock["tag"]) {
          case "VIN":
            if (config["single-image"]["guidance-text"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box"
              );
            break;
          case "Odometer":
            if (config["single-image"]["guidance-text-odo"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-odo"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box"
              );
            break;
          case "Open Trunk":
            if (config["single-image"]["guidance-text-trunk"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-trunk"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box"
              );
            break;
          case "Gear Shift":
            if (config["single-image"]["guidance-text-gear"])
              guidanceTextRef.current.innerHTML =
                config["single-image"]["guidance-text-gear"];
            else
              guidanceTextRef.current.innerHTML = getTranslateText(
                "Please position inside the white-bordered box"
              );
            break;
          default:
            guidanceTextRef.current.innerHTML = getTranslateText(
              "Please position inside the white-bordered box"
            );
        }
      }
    }, 1000);
  }

  useEffect(() => {
    // whenever editing is enabled, scroll the input into view after render
    if (isEditing && vinInputRef.current) {
      setTimeout(() => {
        vinInputRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        vinInputRef.current.focus();
      }, 300); // small delay ensures keyboard is visible
    }
  }, [isEditing]);

  useEffect(() => {
    if (Object.keys(config["single-image"]).includes("instruction1_tag") && [config["single-image"]["instruction1_tag"]].includes(currentBlock["tag"])) cardDashboardRef.current.style.display = "flex";
    if (Object.keys(config["single-image"]).includes("instruction2_tag") && [config["single-image"]["instruction2_tag"]].includes(currentBlock["tag"])) cardDashboardRef1.current.style.display = "flex";
    startCamera();
    setLandscape(land());
    setFeedbackBtnText(getTranslateText("Recapture image"));
    setWhiteBlock();
    vinCapturedCount = 0;
    checkVin = [];
    imgUrl = null;
    setMessage("");
    imageCaptured = false;
    feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setLandscape(land());
      if (!land()) setCameraOpenFlag(false);
      else if (land()) {
        if (!getCameraOpenFlag()) setTimeout(() => startCamera(), 100);
      }
      // if (land() && getCameraOpenFlag()) setTimeout(() => startCamera(), 100);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (window.stream) {
        window.stream.getTracks().forEach(track => track.stop());
        window.stream = null;
      }
    }
  }, []);


  return (
    <Fragment>
      {!isLandscape ? (
        <Rotate />
      ) : (
        <div
          id="vin-screen"
          ref={singleScreen}
          style={{
            height: ["porto_seguros"].includes(clientId) ? "90dvh" : "100dvh",
            overflowY: "auto"
          }}
        >
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>
          <video
            ref={videoRef}
            id="videoWindow"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
            autoPlay
            playsInline
          ></video>
          <div ref={cardDashboardRef} id="display-card-dashboard">
            <div style={{ display: "flex", alignItems: "center", "justifyContent": "space-between", width: "100%", paddingTop: "2%" }}>
              <div id="image-container" style={{ width: "unset", paddingLeft: "2%" }}>
                <img style={{ width: "45dvw", borderRadius: "5%", height: "60dvh" }} src={dashboard}></img>
              </div>
              <div id="dashboard-points">
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-One"]
                    : getTranslateText("Photo of the interior of the vehicle that must show the steering wheel, radio, and glove compartment.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-Two"]
                    : getTranslateText("To get a good photo, we recommend taking it from the back seat, between the headrests of the front seats, so the entire dashboard is visible.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-Three"]
                    : getTranslateText("The photo will be considered incorrect if it is cut off at any point or if an object prevents the dashboard from being seen completely.")}</p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "white",
                  width: "20%",
                  height: "100%",
                  borderRadius: "10px",
                  border: "none",
                }}
                onClick={() => {
                  cardDashboardRef.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>
          <div ref={cardDashboardRef1} id="display-card-dashboard">
            <div style={{ display: "flex", alignItems: "center", "justifyContent": "space-between", width: "100%", paddingTop: "2%" }}>
              <div id="image-container" style={{ width: "unset", paddingLeft: "2%" }}>
                <img style={{ width: "45dvw", borderRadius: "5%", height: "60dvh" }} src={Object.keys(config["single-image"]).includes("document-inst1_img") ? config["single-image"]["document-inst1_img"] : "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/odometerInstruction.jpg"}></img>
              </div>
              <div id="dashboard-points">
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-One"]
                    : getTranslateText("Start the vehicle and keep the engine idling (RPM at 0).")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-Two"]
                    : getTranslateText("Ensure the total mileage (odometer reading) is clearly visible.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-Three"]
                    : getTranslateText("Capture the complete instrument panel, including the speedometer and tachometer.")}</p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "white",
                  width: "20%",
                  height: "100%",
                  borderRadius: "10px",
                  border: "none",
                }}
                onClick={() => {
                  cardDashboardRef1.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>
          {["VIN"].includes(currentBlock["tag"]) && (
            <div ref={cardRef} id="display-card-vin">
              <div id="image-container" style={{ width: "65dvw" }}>
                <img style={{ width: "80%" }} src={Object.keys(config["single-image"]).includes("vin_popup_img") ? config["single-image"]["vin_popup_img"] : VINImg}></img>
              </div>
              <div id="btn-container">
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    color: "white",
                    width: "20%",
                    height: "100%",
                    borderRadius: "10px",
                    border: "none",
                  }}
                  onClick={() => {
                    cardRef.current.style.display = "none";
                    redLineVINcontainer.current.style.display = "flex";
                    startBtn.current.style.display = "block";
                  }}
                >
                  {Object.keys(config["single-image"]).includes("btnVinText")
                    ? config["single-image"]["btnVinText"]
                    : getTranslateText("Ok got it")}
                </button>
              </div>
            </div>
          )}
          {["VIN", "Odometer", "Open Trunk", "Gear Shift", "Fuel tank"].includes(
            currentBlock["tag"]
          ) && (
              <div
                className="redLineVINcontainerView"
                style={{
                  height: ["porto_seguros"].includes(clientId)
                    ? "90dvh"
                    : "100dvh",
                }}
                ref={redLineVINcontainer}
              >
                <div id="modalNameCont">
                  <p id="modalNameText">{currentBlock["id"]}</p>
                </div>
                <div
                  className="redLineVIN"
                  style={{
                    width: "70vw",
                    height:
                      currentBlock.tag === "VIN"
                        ? "40vh"
                        : ["porto_seguros"].includes(clientId)
                          ? "47vh"
                          : "70vh",
                  }}
                ></div>
                <div id="guidanceText" style={{ width: "auto" }}>
                  <p
                    style={
                      ["porto_seguros", "porto_seguros_uat"].includes(
                        clientId
                      )
                        ? { fontSize: "15px" }
                        : {}
                    }
                    ref={guidanceTextRef}
                    id="guidanceParaText"
                  ></p>
                </div>
              </div>
            )}
          <div
            ref={startBtn}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
            onClick={captureImg}
            id="btn-vin-start"
          ></div>
          <div ref={backRef} className="back-btn">
            <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
          </div>
          {Object.keys(currentBlock).includes("cameraInstruction") && (
            <div className="camerInst">
              <p>{currentBlock["cameraInstruction"]}</p>
            </div>
          )}
          <div
            id="vin-image"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
            ref={imgRef}
          >
            <div id="display-card-success-top" ref={feedbackSuccessTopPopRef}>
              <div className="success-section">
                <div className="success-icon-wrapper">
                  <Check className="success-icon" strokeWidth={3} />
                </div>
                <div className="success-text-wrapper">
                  <h1 className="success-title">
                    {
                      getTranslateText("# Detected Successfully!").replace("#", currentBlock["id"])
                    }
                  </h1>
                  {
                    Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] && <p className="success-subtitle">
                      {getTranslateText("Please verify the information detected below.")}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div ref={feedBackPopUp} id="display-card-zizo">
              <div ref={headerText1} id="zizo-loader-text" style={{ textAlign: "center", display: "block", padding: "5dvh 1dvh 5dvh 1dvh" }}>
                <h3 style={{ margin: "0px" }} ref={feedBackPopText}></h3>
              </div>
              <div
                ref={imageRef}
                id="zizo-loader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img ref={carInspectionRef} src={car_inspection} alt="123" style={{ zIndex: 5, width: "17dvw", height: "unset", borderRadius: "2%", padding: "0px 0px 2dvh 0px" }} />
              </div>
              <div ref={feedbackBtnRef} style={{ display: "none", padding: "0px 0px 2dvh 0px", width: "100%", alignContent: "center", justifyContent: "center" }}>
                <button
                  className="feedbackbtn"
                  style={{ backgroundColor: config["colors"]["btn"], fontSize: "medium" }}
                  onClick={() => {
                    feedBackPopUp.current.style.display = "none";
                    crossTickBtn.current.style.display = "block";
                    ++vinCapturedCount;
                    imageRetake();
                  }}
                >
                  {feedbackBtnText}
                </button>
              </div>
            </div>
            <div id="display-card-success-bottom" ref={feedbackSuccessBottomPopRef}>
              {/* --- 2. VIN Display/Edit Section --- */}
              <div id="vin-edit-section">
                <label style={{ color: "#ffffffde", fontSize: '13px', fontWeight: '600', margin: "0px", padding: "5px 0px 5px 5px" }}>{getTranslateText("Detected #:").replace("#", currentBlock["id"])}</label>

                {isEditing ? (
                  <>
                    <input
                      type="text"
                      value={message}
                      onChange={handleVinChange}
                      onBlur={() => {
                        setMessage(formatVinForDisplay(message));
                        setIsEditing(false);
                        if (vinEditToastId) {
                          toast.dismiss(vinEditToastId); // Dismiss any lingering toast
                          vinEditToastId = null;
                        }
                      }}
                      autoFocus
                      id="vin-input"
                      ref={vinInputRef}
                    />
                  </>
                ) : (
                  <div style={{ width: '100%', textAlign: 'left', paddingLeft: "5px" }}>
                    <span style={{ fontSize: '24px', fontWeight: '800', color: 'white', letterSpacing: '1px' }}>{formatVinForDisplay(message)}</span>
                  </div>
                )}
                {
                  Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] &&
                  <>
                    <div style={{ position: 'absolute', top: '12px', right: '12px', width: "5dvw", height: "6dvh" }}>
                      <div onClick={() => setIsEditing(true)} className="icon-btn">
                        <img src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/edit-icon.png" alt="123" style={{ width: "3.5dvw", objectFit: "unset", height: "unset" }} />
                      </div>
                    </div>
                    <div className="input-footer">
                      <span className="input-status">
                        {isEditing ? getTranslateText("Editing enabled") : getTranslateText("Tap edit icon to modify")}
                      </span>
                    </div>
                  </>
                }
              </div>
              {
                Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] &&
                <div style={{ display: "flex", padding: "0px 0px 2dvh 0px", alignContent: "center", justifyContent: "center", width: "180px", borderRadius: "5px" }}>
                  <button
                    className="feedbackbtn"
                    style={{ backgroundColor: config["colors"]["btn"], fontSize: "medium" }}
                    onClick={() => {
                      if (message.length < 17) {
                        toast.error(getTranslateText("# must be 17 characters long.").replace("#", currentBlock["id"]), {
                          theme: "colored",
                        });
                        return;
                      }
                      feedbackSuccessTopPopRef.current.style.display = "none";
                      feedbackSuccessBottomPopRef.current.style.display = "none";
                      imageNext();
                    }}
                  >
                    {feedbackBtnText}
                  </button>
                </div>
              }
            </div>
            <img
              ref={divImgRef}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            />
            <div ref={crossTickBtn} className="cross-tick-btn">
              <i
                className="fas fa-times fa-2x vin-btn-retake"
                onClick={imageRetake}
              ></i>
              <i
                className="fas fa-check fa-2x vin-btn-next"
                onClick={() => {
                  if (getVinFeedback() && !["client_1511", "client_1298", "client_1298_prod", "client_1298_dev"].includes(clientId) && currentBlock["tag"] === "VIN" && vinCapturedCount === 0) {
                    vinCheckingHanlder();
                  }
                  else imageNext();
                }}
              ></i>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default SingleImage;
